module.exports = __webpack_public_path__ + "static/media/snooker-icon.f715185c.svg";